import { createContext, useContext, useEffect, useState } from 'react';
import { getFingertipsLinks, getSavingsSnapshot, getOtherCompanyBenefits } from '../services/dashboard';
import { getAllCompanies } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type DcDashboardState = {
  fingertipLinks: Array<any>;
  companiesMessages: Array<any>;
  savingsSnapshot: Array<any>;
  otherCompanyBenefits: Array<any>;
};

export const DcDashboardStore = createContext<DcDashboardState>({
  fingertipLinks: [],
  companiesMessages: [],
  savingsSnapshot: [],
  otherCompanyBenefits: [],
});

const { Provider } = DcDashboardStore;

export const DcDashboardProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [dcDashboardState, setDcDashboardState] = useState<DcDashboardState>({
    fingertipLinks: [],
    companiesMessages: [],
    savingsSnapshot: [],
    otherCompanyBenefits: [],
  });

  useEffect(() => {
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let companiesMessages = getAllCompanies(selectedPersona);
    let savingsSnapshot = getSavingsSnapshot();
    let otherCompanyBenefits = getOtherCompanyBenefits();

    setDcDashboardState({
      fingertipLinks,
      companiesMessages,
      savingsSnapshot,
      otherCompanyBenefits,
    });
  }, [selectedPersona]);

  return <Provider value={dcDashboardState}>{children}</Provider>;
};
